module.exports = __webpack_public_path__ + "img/facebook.fb0e58f3.svg";